import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL } from '../constants';
import { Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import VerifiedIcon from '@mui/icons-material/Verified';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function EditClientNotes (props) {
    
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setNotes(props.notes === null ? "" : props.notes);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        props.setRecentAppointmentConfirm(true);
        props.redirectToHome();
    };

    const[notes, setNotes] = useState("");

    const handleChange = (event) => {
        setNotes(event.target.value);
    }

    const handleSave = () => {
        updateNotes();
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            // e.preventDefault();
            // handleSave();
        }
    }

    const updateNotes= () => {
        // console.log('updateNotes');
        // console.log("props.appointmentId", props.appointmentId);
        // console.log('notes ', notes);
        // return;
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/send-message',
        {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "appointment_id" : props.appointmentId,
                "notes" : notes
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                console.log("success");
                props.setRecentAppointmentConfirm(true);
                props.redirectToHome();
            }
            else {
                
            }
        })
        .catch(err => console.error(err))
    }

    return(
        <React.Fragment>
            {props.showBUtton ?
            <IconButton
                    onClick={handleClickOpen}
                    size="medium"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                <EditIcon fontSize='medium' />
            </IconButton>
            : null }
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                // open={open || props.openSendMessageModal}
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    > 
                        <Typography 
                            sx={{ 
                                lineHeight: 1.2, 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1 
                            }} 
                            variant="h6"
                        >
                            <VerifiedIcon fontSize='large' />
                            Congratulations!
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ m: 0, p: 0 }} >
                    <Typography 
                    sx={{ 
                        lineHeight: 1.2,
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }} 
                    variant="body1"
                    >
                        Your appointment is confirmed
                    </Typography>
                    <br />
                    <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                    {`Type any additional information (i.e. purpose of visit, your condition, requests, etc.)`}
                    </Typography>
                    <Typography sx={{ textAlign: 'right' }}>
                        - {props.officeName}
                    </Typography>
                    <br />
                    <TextField
                        sx={{ width: 1 }}
                        name='notes'
                        value={notes}
                        id="outlined-multiline-static"
                        label="(Optional Information)"
                        multiline
                        minRows={4}
                        maxRows={8}
                        inputProps={{ maxLength: 400 }}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyDown={handleKeyPress}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >Not Now</Button>
                    <Button disabled={!notes} onClick={handleSave} >Send Info</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default EditClientNotes;